import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateSourcingResumeBatchRequest,
  HttpResponse,
  SourcingResumeBatch,
} from "@/types";

export function useCreateSourcingResumeBatch() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useMutation({
    mutationFn: async ({
      createSourcingResumeBatchRequest,
    }: {
      createSourcingResumeBatchRequest: CreateSourcingResumeBatchRequest;
    }) => {
      // Built by hand rather than with postForm: multer matches the field name
      // exactly, and axios would serialize the array as "resumes[0]".
      const formData = new FormData();
      formData.append("source", createSourcingResumeBatchRequest.source);
      for (const resume of createSourcingResumeBatchRequest.resumes) {
        formData.append("resumes", resume);
      }

      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/sourcing-resume-batches`;
      const res = await guacHttpClient.post<
        SourcingResumeBatch,
        HttpResponse<SourcingResumeBatch>
      >(path, formData);

      return res.data;
    },
  });
}
